import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppConfigService } from '../../services/app-config.service';
import { MyRouter } from '../../../common/services/router.service';
import { OpcoPolicyLinksService } from '../../services/opco-policy-links.service';

@Component({
    selector: 'app-nav-mobile',
    templateUrl: './nav-mobile.component.html',
    styleUrls: ['./nav-mobile.component.scss']
})
export class NavMobileComponent {
    @Input() isAuthorized: boolean;
    @Input() isOciUser: boolean;

    @Output() logout = new EventEmitter<void>();

    headerImage = this.appConfigService.getAppConfig().opCoImage || 'mateco.svg';
    termsAndConditionsLink: string;
    privacyPolicyLink: string;
    cookiePolicyLink: string;


    constructor(private appConfigService: AppConfigService,
                private opCoPolicyLinksService: OpcoPolicyLinksService,
                private router: MyRouter) {
    }

    navigateTo(url: string[]) {
        this.router.navigateWithCorporateClient(url);
    }

    clickHeaderImage() {
        this.router.navigateWithCorporateClient(this.isAuthorized ? ['/orders'] : ['/login']);
    }

    getPolicyLinks() {
        this.termsAndConditionsLink = this.opCoPolicyLinksService.getTermsConditionLink();
        this.privacyPolicyLink = this.opCoPolicyLinksService.getPrivacyPolicyLink();
        this.cookiePolicyLink = this.opCoPolicyLinksService.getCookiePolicyLink();
    }

    openCookieSettings() {
        (window as any).openKlaroDialog();
    }
}
